var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var TranslationController = {
    /*****************************************************************************************************
        * Is using route "api/translate/{to}" and http method "POST" to call the back-end.
    
        * @param {string} to
        * @param {TranslationSet} set
        * @returns {TranslationSet}
    ******************************************************************************************************/
    Translate: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("set", JSON.stringify(data.set));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/{to}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/lngString/toLngs" and http method "POST" to call the back-end.
    
        * @param {string[]} toLngs
        * @param {LanguageStringUploadDto[]} toTranslate
        * @returns {LanguageStringDownloadDto[]}
    ******************************************************************************************************/
    TranslateLngString: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("toLngs", JSON.stringify(data.toLngs));
        fd.append("toTranslate", JSON.stringify(data.toTranslate));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/lngString/toLngs", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/{to}/post" and http method "POST" to call the back-end.
    
        * @param {string} to
        * @param {PostDownloadDto} post
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    TranslatePost: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("post", JSON.stringify(data.post));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/{to}/post", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/downloadXliff/{id}/{baseLanguage}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} baseLanguage
        * @returns {LinkDto}
    ******************************************************************************************************/
    DownloadPostTranslationXliff: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/downloadXliff/{id}/{baseLanguage}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/state/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {TranslationStateDownloadDto}
    ******************************************************************************************************/
    GetPostTranslationState: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/state/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/downloadGroupXliff/{groupId}/{baseLanguage}/{redownloadInTranslation?}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} baseLanguage
        * @param {boolean} redownloadInTranslation
        * @returns {LinkDto}
    ******************************************************************************************************/
    DownloadGroupTranslationXliff: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/downloadGroupXliff/{groupId}/{baseLanguage}/{redownloadInTranslation?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/downloadGroupXliffWithoutHistory/{groupId}/{baseLanguage}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} baseLanguage
        * @param {FetchPostsFilter} filter
        * @returns {LinkDto}
    ******************************************************************************************************/
    DownloadGroupTranslationXliffWithoutHistory: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/downloadGroupXliffWithoutHistory/{groupId}/{baseLanguage}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/importXliff" and http method "POST" to call the back-end.
    
        * @param {File} file
        * @returns {LinkDto}
    ******************************************************************************************************/
    ImportXliff: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.file)
            fd.append("file", data.file);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/importXliff", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/importXliffsPackage/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} zipFile
        * @returns {void}
    ******************************************************************************************************/
    ImportXliffsPackage: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.zipFile)
            fd.append("zipFile", data.zipFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/importXliffsPackage/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/importImagesPackage/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} zipFile
        * @returns {void}
    ******************************************************************************************************/
    ImportImagesPackage: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.zipFile)
            fd.append("zipFile", data.zipFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/importImagesPackage/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/importTranslationPackage/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} packageZip
        * @returns {void}
    ******************************************************************************************************/
    ImportTranslationPackage: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.packageZip)
            fd.append("packageZip", data.packageZip);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/importTranslationPackage/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/importTranslationPackageLocal/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @returns {void}
    ******************************************************************************************************/
    ImportTranslationPackageLocal: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/importTranslationPackageLocal/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/resetBeforeTranslation" and http method "POST" to call the back-end.
    
        * @returns {void}
    ******************************************************************************************************/
    ResetBeforeTranslation: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/resetBeforeTranslation", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/exportTranslationPackage/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {FetchPostsFilter} filter
        * @param {string[]} additionalIds
        * @returns {void}
    ******************************************************************************************************/
    ExportTranslationPackage: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        if (data.additionalIds !== undefined)
            fd.append("additionalIds", JSON.stringify(data.additionalIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/exportTranslationPackage/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/sendTranslationPackage/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {TranslationProjectStateUploadDto} project
        * @param {FetchPostsFilter} filter
        * @param {string[]} additionalIds
        * @returns {void}
    ******************************************************************************************************/
    SendTranslationPackage: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("project", JSON.stringify(data.project));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        if (data.additionalIds !== undefined)
            fd.append("additionalIds", JSON.stringify(data.additionalIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/sendTranslationPackage/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/receiveTranslationPackage/{translationProjectStateId}" and http method "POST" to call the back-end.
    
        * @param {string} translationProjectStateId
        * @returns {TranslationProjectStateDownloadDto}
    ******************************************************************************************************/
    ReceiveTranslationPackage: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/receiveTranslationPackage/{translationProjectStateId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/importTranslationPackageFromStorage/{translationProjectStateId}" and http method "POST" to call the back-end.
    
        * @param {string} translationProjectStateId
        * @returns {TranslationProjectStateDownloadDto}
    ******************************************************************************************************/
    ImportTranslationPackageFromStorage: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/importTranslationPackageFromStorage/{translationProjectStateId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/translate/callbackMessage/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    CallbackMessage: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/callbackMessage/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/translate/callbackMessageGlobalLink/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    CallbackMessageGlobalLink: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/callbackMessageGlobalLink/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/translate/acolad" and http method "POST" to call the back-end.
    
        * @returns {void}
    ******************************************************************************************************/
    CallbackMessageAcolad1: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/acolad", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/resetTranslationState/{groupId}/{prepareDemo}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {boolean} prepareDemo
        * @returns {void}
    ******************************************************************************************************/
    ResetTranslationStates: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/resetTranslationState/{groupId}/{prepareDemo}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/translationStates/{groupId}/{untranslated?}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @param {boolean} untranslated
        * @returns {TranslationStateDownloadDto[]}
    ******************************************************************************************************/
    GetTranslationStates: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/translationStates/{groupId}/{untranslated?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/translate/translationProjectStates/{groupId}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {TranslationProjectStateDownloadDto[]}
    ******************************************************************************************************/
    GetTranslationProjectStates: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/translationProjectStates/{groupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/translate/callbackTranslationFinished/{translationProjectId}" and http method "POST" to call the back-end.
    
        * @param {string} translationProjectId
        * @returns {void}
    ******************************************************************************************************/
    CallbackTranslationFinished: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/callbackTranslationFinished/{translationProjectId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/translate/providerSettings/{provider}/{projectId?}" and http method "GET" to call the back-end.
    
        * @param {TranslationProjectProvider} provider
        * @param {string} projectId
        * @returns {TranslationProviderSettingsDownloadDto}
    ******************************************************************************************************/
    GetProviderSettings: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/translate/providerSettings/{provider}/{projectId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=TranslationController.js.map